import React from "react";
import { useIntl } from "gatsby-plugin-react-intl";

import whiteLogo from "../../images/axur-logo-white.svg";
import logo from "../../images/axur-logo.svg";

import * as S from "./styled";

export default function Logo({ nameLogo }) {
  const intl = useIntl();

  return (
    <S.LogoWrapper href={`https://www.axur.com/`}>
      <img
        alt={intl.formatMessage({ id: "tagline" })}
        src={nameLogo === "white-logo" ? whiteLogo : logo}
        placeholder="Logo Axur"
      />
    </S.LogoWrapper>
  );
}
